import React from 'react';
import {
    useSsSelector as useSelector,
} from '~SpectateStore';
import { useTranslation } from 'react-i18next';
import { Link } from '~spa/Components/Link/Link';
import {
    betHistoryUrl,
    settledBetsUrl,
} from '~spa/Utils/LocalizedUrls';
import {
    seoUrlBetHistory,
    seoUrlSettledBets,
} from '~spa/Utils/SeoUrls';
import { selectIsRecentlySettledBetsTab } from '~Betslip/selectors/uiSelectors';

const BetHistoryLink = () => {
    const [ t ] = useTranslation();
    const gtmBetslip = 'new-my-bets';
    const isRecentlySettledBetsTab = useSelector(selectIsRecentlySettledBetsTab);
    const betHistoryLink = isRecentlySettledBetsTab
      ? seoUrlSettledBets(`${betHistoryUrl()}/${settledBetsUrl()}`)
      : seoUrlBetHistory(betHistoryUrl());

    return (
        <Link
            to={betHistoryLink}
            data-bb-modal-close
            data-bb-tools="betslip;full-bet-history"
            gtmAttribute={`${gtmBetslip};see-full-bet-history`}
            className="bet-history__bs-link"
        >
            <p className="bet-history__bs-title">{t('bet_history.see_bet_history')}</p>
        </Link>
    );
};

export default BetHistoryLink;
